// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9b3c7b2d","178":"ec0dedc5","218":"fff620d6","240":"969864cb","333":"7d8a9ab5","408":"30c091d4","453":"ace21015","483":"a496e296","500":"c4a8c477","506":"bd69039a","556":"b9a71009","874":"bde114c3"}[chunkId] + ".chunk.js";
};